document.addEventListener('turbo:load', function () {
  const toggleHeader = document.getElementById('recent-searches-toggle');
  const toggleContent = document.getElementById('recent-searches-content');
  const toggleIndicator = document.getElementById('toggle-indicator');

  if (toggleHeader && toggleContent && toggleIndicator) {
    // Initialize the indicator based on the content visibility
    const isContentHidden = getComputedStyle(toggleContent).display === 'none';
    toggleIndicator.textContent = isContentHidden ? '▼' : '▲';

    // Add click event to toggle visibility
    toggleHeader.addEventListener('click', () => {
      const isHidden = toggleContent.style.display === 'none' || toggleContent.style.display === '';

      // Toggle the display
      toggleContent.style.display = isHidden ? 'block' : 'none';

      // Update the indicator
      toggleIndicator.textContent = isHidden ? '▲' : '▼';
    });
  }
});
